<template>
  <el-dialog
    title="设备详情"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-table :data="deviceDetails"  v-loading="loading">
      <el-table-column prop="saleId" label="销售单编码" width="150" align="center"/>
      <el-table-column prop="deviceFamily" label="设备类型" width="150" align="center">
        <template #default="{row}">
          {{ deviceTypeMap[row.deviceFamily] || '未知类型' }}
        </template>
      </el-table-column>
      <el-table-column prop="deviceName" label="设备名称" width="120" align="center"/>
      <el-table-column prop="deviceModel" label="型号" width="150" align="center"/>
      <el-table-column prop="devicePrice" label="单价" width="120" align="center">
        <template #default="{row}">
          {{ row.devicePrice.toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column prop="actualNumber" label="设备数量" width="100" align="center"/>
      <el-table-column prop="onLineAmount" label="设备上线数量" width="150" align="center"/>
      <el-table-column prop="refundAmount" label="设备退款数量" width="150" align="center"/>
      <el-table-column prop="devicePort" label="端口数" width="100" align="center"/>
      <el-table-column prop="orderStatus" label="下单状态" width="120" align="center">
        <template #default="{row}">
          <el-tag :type="orderStatusTag(row.orderStatus)" size="small">
            {{ orderStatusMap[row.orderStatus] }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      :current-page="currentPage"
      :page-size="pageSize"
      :total="total"
      layout="prev, pager, next, sizes"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
      style="margin-top: 15px"
    />
  </el-dialog>
</template>

<script>
import {service} from '../../../utils/axios'

export default {
  name: 'DeviceDetailDialog',
  props: {
    visible: Boolean,
    saleId: String
  },
  data () {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      loading: false,
      deviceDetails: [],
      deviceTypeMap: {
        0: '电瓶车充电桩',
        7: '汽车直流桩',
        8: '汽车交流桩'
      },
      orderStatusMap: {
        0: '未提交',
        1: '未预付款',
        2: '已预付款',
        3: '已下单',
        4: '已完成',
        5: '作废'
      },
      dialogVisible: this.visible // 本地副本
    }
  },
  watch: {
    saleId: {
      immediate: true,
      handler (newVal) {
        if (newVal) {
          this.dialogVisible = this.visible
          this.fetchDeviceDetails()
        }
      }
    }
  },
  methods: {
    async fetchDeviceDetails () {
      try {
        this.loading = true
        const res = await service.get('/website/deviceSalesDetail/page', {
          params: {
            parentId: this.saleId,
            pageNo: 1,
            pageSize: 10
          }
        })
        this.deviceDetails = res.result.records
        this.total = res.result.total // 假设接口返回总条数字段为total
      } catch (error) {
        console.error('获取设备详情失败:', error)
        this.$message.error('获取设备详情失败')
      } finally {
        this.loading = false
      }
    },
    orderStatusTag (status) {
      const map = {
        0: 'info',
        1: 'warning',
        2: '',
        3: 'primary',
        4: 'success',
        5: 'danger'
      }
      return map[status] || ''
    },
    // 新增分页处理方法
    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchDeviceDetails()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchDeviceDetails()
    },
    handleClose () {
      this.dialogVisible = false
      this.$emit('update:visible', false)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/lcc/components/DeviceDetailDialog.vue